export const defaultRequestOptions = {
  method: 'GET',
} as const;
